import { createContext, createElement, useCallback, useContext, useEffect, useState, } from 'react';
import { api } from '../api';
import { storageGet, storageRemove, storageSet } from '../safeStorage';
const TOKEN_KEY = 'gestiora.token';
const AuthContext = createContext(null);
// Provider ÚNICO: valida la sesión UNA vez y comparte el estado con toda la app.
// Antes `useAuth` era un hook independiente por componente → cada navegación
// re-verificaba /auth/me y mostraba blanco hasta refrescar. Con el context el
// estado persiste entre rutas (sin parpadeo ni recarga manual).
export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const token = storageGet(TOKEN_KEY);
        if (!token) {
            setLoading(false);
            return;
        }
        api
            .get('/auth/me')
            .then((r) => setUser(r.data))
            .catch(() => storageRemove(TOKEN_KEY))
            .finally(() => setLoading(false));
    }, []);
    const login = useCallback(async (email, password) => {
        const r = await api.post('/auth/login', { email, password });
        storageSet(TOKEN_KEY, r.data.token);
        setUser(r.data.user);
    }, []);
    const register = useCallback(async (email, password, locale) => {
        const loc = (locale || 'es').toLowerCase().split(/[-_]/)[0];
        await api.post('/auth/register', { email, password, locale: loc });
        await login(email, password);
    }, [login]);
    const logout = useCallback(async () => {
        try {
            await api.post('/auth/logout');
        }
        catch {
            /* ignore */
        }
        storageRemove(TOKEN_KEY);
        setUser(null);
    }, []);
    return createElement(AuthContext.Provider, { value: { user, loading, login, register, logout } }, children);
}
export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx)
        throw new Error('useAuth debe usarse dentro de <AuthProvider>');
    return ctx;
}
